import React from 'react';
import { useNavigate } from 'react-router-dom';

const GiftCardGrid = ({ giftCards = [] }) => {
  const navigate = useNavigate();

  const openDetails = (giftCard) => {
    const code = String(giftCard?.giftCardCode || '').trim();
    if (!code) return;

    navigate(`/admin/gift-cards/${encodeURIComponent(code)}`, {
      state: { giftCard },
    });
  };

  return (
    <div className="table-responsive">
      <table className="table align-middle">
        <thead>
          <tr>
            <th>Description</th>
            <th>Initial Amount</th>
            <th>Issued Date Amount</th>

            <th style={{ width: 140 }}>Action</th>
          </tr>
        </thead>

        <tbody>
          {giftCards?.length ? (
            giftCards.map((gc, idx) => (
              <tr key={gc?.giftCardCode ?? idx} style={{ cursor: 'pointer' }} onClick={() => openDetails(gc)}>
                <td>{gc?.itemDescription || '-'}</td>
                <td>{gc?.initialAmount ?? '-'}</td>
                <td>{gc?.issuedDate ? new Date(gc?.issuedDate).toLocaleDateString() : '-'}</td>

                <td onClick={(e) => e.stopPropagation()}>
                  <button className="addItem-btn p-2" onClick={() => openDetails(gc)}>
                    View / Edit
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={3} className="text-center">
                No gift cards found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default GiftCardGrid;
